import React, { Component } from 'react'
import { Grid, IconButton, List, ListItem, Box } from '@material-ui/core'
import PlayArrowIcon from '@material-ui/icons/PlayArrow'
import PauseIcon from '@material-ui/icons/Pause'
import { withStyles } from '@material-ui/core/styles'
import withWidth, { isWidthUp } from '@material-ui/core/withWidth'
import useStyles from './styles/PlaylistStyle'
import { getDuration }  from '../../services/Utils'
import Slider from "react-slick"
import './styles/slick.css'


const PlaylistItemDesktop = props => {
  const classes = props.classes;
  const { isPlaying, title, duration, active, mediaId, setIsPlaying } = props
  const itemTitleClass = active ? `playlist-active-item-title` : `playlist-inactive-item-title`
  return (
    <Grid container direction="row" onClick={() => setIsPlaying(!isPlaying, mediaId)} className={classes.desktopListItemContainer} >
      <Grid item container sm={10} direction="column" justify="space-around">
        <Grid item>
          <Box
            component="div"
            overflow="hidden"
            className={`${classes.desktopListItemText} ${itemTitleClass}`}
            style={{opacity: active ? 1 : 0.8}}
            classes={{root: classes.twoTextLinesBox}}>
            {title}
          </Box>
        </Grid>
        <Grid item className={classes.desktopListItemDurationContainer} >
          <Box className={`${classes.desktopListItemDurationText} ${active? `playlist-playing-title` :`playlist-item-duration`}`} >
            {active? 'PLAYING...' : duration}
          </Box>
          <Grid item className={`${classes.desktopListItemDivider} playlist-item-divider`} />
        </Grid>
      </Grid>
      <Grid item container sm={2} alignItems={'center'} justify={'flex-end'}>
        <IconButton disableRipple={true} className={classes.desktopListItemIconButton} >
          {(isPlaying && active) ? (
            <PauseIcon className={`playlist-active-play-pause-icon`} />
          ) : (
            <PlayArrowIcon className={active? `playlist-active-play-pause-icon` : `playlist-inactive-play-icon`} />
          )}
        </IconButton>
      </Grid>
    </Grid>
  )
}

const PlaylistItemMobile = props => {
  const classes = props.classes;
  const { isPlaying, title, duration, active, mediaId, setIsPlaying } = props
  return (
    <Grid container direction="row" className={`${classes.mobileListItemContainer} playlist-mobile-item-container`} >
      <Grid item container sm={10} direction="column" justify="space-around" className={classes.mobileListItemTextsContainer} >
        <Grid item>
          <Box
            component="div"
            overflow="hidden"
            className={`${classes.mobileListItemText} playlist-active-item-title`}
            style={{opacity: active ? 1 : 0.8}}
            classes={{root: classes.twoTextLinesBox}}>
            {title}
          </Box>
        </Grid>
        <Grid item className={classes.mobileListItemDurationContainer} >
          <Box className={`${classes.mobileListItemDurationText} playlist-item-duration`} >
            {duration}
          </Box>
        </Grid>
      </Grid>
      <Grid item container sm={2} alignItems={'center'} justify={'flex-end'}>
        <IconButton onClick={() => setIsPlaying(!isPlaying, mediaId)} disableRipple={true} className={classes.mobileListItemIconButton} >
          {(isPlaying && active) ? (
            <PauseIcon className={`playlist-active-play-pause-icon`} />
          ) : (
            <PlayArrowIcon className={active? `playlist-active-play-pause-icon` : `playlist-inactive-play-icon`} />
          )}
        </IconButton>
      </Grid>
    </Grid>
  )
}

class PlayerPlaylist extends Component {
  constructor(props) {
    super(props)

    this.state = {
      mobileSliderSlide: 0,
      windowWidth: window.innerWidth,
    }

    this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount() {
    // the handleResize method will be invoked every time the window will get resized
    window.addEventListener('resize', this.handleResize);
  }

  // This method is invoked every time the window is resized.
  handleResize() {
    this.setState({
      windowWidth: window.innerWidth
    })
  }

  componentDidUpdate(prevProps) {
    if (this.props.mediaId !== prevProps.mediaId) {
      let prevPlayingVideoIndex = this.props.playlist.findIndex(item => item.payload_id === prevProps.mediaId)
      let playingVideoIndex = this.props.playlist.findIndex(item => item.payload_id === this.props.mediaId)
      this.setState({
        playingVideoIndex
      })
      if (this.slider && this.state.mobileSliderSlide === prevPlayingVideoIndex) {
        this.slider.slickGoTo(playingVideoIndex)
        this.setState({mobileSliderSlide: playingVideoIndex})
      }
    }
    if (this.slider && !isWidthUp('md', this.props.width) && isWidthUp('md', prevProps.width)) { // changed to sm
      let playingVideoIndex = this.props.playlist.findIndex(item => item.payload_id === this.props.mediaId)
      this.slider.slickGoTo(playingVideoIndex)
      this.setState({mobileSliderSlide: playingVideoIndex})
    }
  }

  renderDesktop() {
    const classes = this.props.classes;
    return (
      <Grid container item direction="column" className={classes.desktopContainer} >
        <Grid item>
          <Box className={`${classes.desktopNextUpText} playlist-next-up`} >
              NEXT UP
          </Box>
        </Grid>
        <Grid item container direction="column" className={classes.desktopListContainer} >
          <List className={`${classes.desktopList} playlist-scrollbar`} style={{ height: this.state.windowWidth * 0.4 }}disablePadding={true}>
            {this.props.playlist.map((item, index) => {
              return (
                <ListItem key={index} style={{padding: 0}}>
                  <PlaylistItemDesktop
                    isPlaying={this.props.isPlaying}
                    mediaId={item.payload_id}
                    active={this.props.mediaId === item.payload_id}
                    duration={getDuration(item.duration)}
                    title={item.title}
                    setIsPlaying={this.props.setIsPlaying}
                    classes={classes}
                  />
                </ListItem>
              )
            })}
            <ListItem key={this.props.playlist.length} className={classes.desktopListFooterItem} />
          </List>
          <Box className={`${classes.desktopGradientBox} playlist-desktop-gradient`} />
        </Grid>
      </Grid>
    )
  }

  renderMobile() {
    const classes = this.props.classes;
    const sliderSettings = {
      arrows: false,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 300,
      dots: true
    }
    return (
      <Grid container item direction="column" className={classes.mobileContainer} >
         <Grid item>
           <Box className={`${classes.mobileNextUpText} playlist-next-up`} >
             NEXT UP
           </Box>
         </Grid>
        <Grid item lg={12} md={12} sm={12}>
          <Slider
            className={classes.mobileSlider}
            ref={c=> (this.slider=c)}
            {...sliderSettings}
            afterChange={(currentSlide) => {this.setState({mobileSliderSlide: currentSlide})}}
          >
            {this.props.playlist.map((item, index) =>
              <PlaylistItemMobile
                isPlaying={this.props.isPlaying}
                mediaId={item.payload_id}
                key={index}
                active={this.props.mediaId === item.payload_id}
                duration={getDuration(item.duration)}
                title={item.title}
                setIsPlaying={this.props.setIsPlaying}
                classes={classes}
            />
            )}
          </Slider>
        </Grid>
      </Grid>
    )
  }

  render() {
    return (isWidthUp('md', this.props.width)) ? this.renderDesktop() : this.renderMobile()
  }
}

export default withStyles(useStyles)(withWidth()(PlayerPlaylist))
